var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kst-output',{attrs:{"print-mode":"","field":"SONumber","data":_vm.data,"catalog":_vm.Catalog}}),_c('kst-output',{attrs:{"print-mode":"","field":"InvoiceDate","data":_vm.data,"catalog":_vm.Catalog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }